import bundle from './localization.json'

const messageBundle: Record<string, Record<string, string>> = bundle

export { messageBundle }
